export default __webpack_public_path__ + "static/media/spiral_1.4b0b74dc.svg";